import { ReportTypes } from 'modules/reports/models';
import { AudienceStatsFilterv1 } from 'modules/insights';
import { reportsApi } from 'api/instances';

export class ReportRequestService {
    static async requestExcelReport(reportFilter: Partial<AudienceStatsFilterv1>, reportType: ReportTypes) {
        try {
            reportsApi.SendAudienceAnalyticsReportRequest(reportFilter, reportType);
            return { success: true, message: "Your report is being generated and will be emailed to you when it's ready." };
        } catch (error) {
            return { success: false, message: "Something went wrong. Please try again." };
        }
    }
}